import Field from './Field';
import Form from './Form';

const FormBoolProps = [
  Form.PROPERTY_FORM_INVISIBLE,
  Form.PROPERTY_FORM_HIDDEN,
  Form.PROPERTY_FORM_CLOSED,
  Form.PROPERTY_FORM_TAB,
  Form.PROPERTY_FORM_HIGHLIGHT,
  Form.PROPERTY_FORM_DONT_FIRE,
  Form.PROPERTY_FORM_READONLY,
  Form.SIGNABLE_FORM,
  Form.MARKED_TO_SIGN,
  Form.REQUIRED_SIGN,
];

const FieldBoolProps = [
  Field.PROPERTY_ALLOW_EDITION,
  Field.PROPERTY_CHECKED,
  Field.PROPERTY_DISABLED,
  Field.PROPERTY_DOCUMENT_COLLAPSE_FLD_STC,
  Field.PROPERTY_DOCUMENT_COLLAPSE_META,
  Field.PROPERTY_DOCUMENT_COLLAPSE_PERM,
  Field.PROPERTY_DOCUMENT_DNT_SHW_DOC_MON,
  Field.PROPERTY_DOCUMENT_EXP_DATE,
  Field.PROPERTY_DOCUMENT_NO_ALLOW_DRAG_DROP,
  Field.PROPERTY_DOCUMENT_NO_SHOW_MODAL,
  Field.PROPERTY_DOCUMENT_SHOW_DESC,
  Field.PROPERTY_DOCUMENT_SHOW_FOLD_TREE_BTN,
  Field.PROPERTY_DOCUMENT_SHOW_FOLD_TREE_STR,
  Field.PROPERTY_FILE_PREVIEW,
  Field.PROPERTY_GRID_ALTER_IN_LAST_PAGE,
  Field.PROPERTY_GRID_HIDE_BTN_ADD,
  Field.PROPERTY_GRID_HIDE_BTN_DEL,
  Field.PROPERTY_GRID_HIDE_BTN_INCLUDE,
  Field.PROPERTY_GRID_HIDE_BTN_ORDER,
  Field.PROPERTY_HIDE_DOC_DOWNLOAD,
  Field.PROPERTY_HIDE_DOC_ERASE,
  Field.PROPERTY_HIDE_DOC_LOCK,
  Field.PROPERTY_HIDE_DOC_METADATA,
  Field.PROPERTY_HIDE_DOC_PERMISSIONS,
  Field.PROPERTY_HIDE_DOC_SIGN,
  Field.PROPERTY_HIDE_DOC_UPLOAD,
  Field.PROPERTY_HIDE_GRID_BTN,
  Field.PROPERTY_INCLUDE_FIRST_ROW,
  Field.PROPERTY_INPUT_AS_TEXT,
  Field.PROPERTY_MODAL_DISABLED,
  Field.PROPERTY_MULTISELECT,
  Field.PROPERTY_NO_DOWNLOAD,
  Field.PROPERTY_NO_ERASE,
  Field.PROPERTY_NO_LOCK,
  Field.PROPERTY_NO_MODIFY,
  Field.PROPERTY_NOT_PRINT,
  Field.PROPERTY_PAGED_GRID,
  Field.PROPERTY_READONLY,
  Field.PROPERTY_REQUIRED,
  Field.PROPERTY_SEL_PARENT,
  Field.PROPERTY_SHOW_TOOLTIP_AS_HELP,
  Field.PROPERTY_SIGNATURE_REQUIRED,
  Field.PROPERTY_STORE_MODAL_QUERY_RESULT,
  Field.PROPERTY_TRANSIENT,
  Field.PROPERTY_TRANSLATION_REQUIRED,
  Field.PROPERTY_VISIBILITY_HIDDEN,
];

const BoolProps: string[] = [...FieldBoolProps, ...FormBoolProps];
export default BoolProps;
